
import es from './es.json';

export default { es };


// WEBPACK FOOTER //
// ./src/locales/localized-urls/index.js